import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import { movil } from "../../app-movil";
import { savePhotoToBucket } from './pagoPorKilometro.act'
import { String } from "es6-shim";

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { Card } from 'material-ui/Card';
import TextFiled from 'material-ui/TextField';
import Modal from '../../generalcomponets/modal-mobile'
import ModalFullScreen from '../../generalcomponets/modal-full-screen'

const mapState = (state) => {
	return {
		"loading": state.global.loading,
		// "poliza": state.polizas.poliza,
		"ts": state.polizas.ts,
		"callTs": state.polizas.callTs,
		"timeout": state.polizas.inactividad,
		// "pagoPorKM": state.polizas.pagoPorKilometro,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		cerrarDetalle: () => {
			dispatch({ "type": "REINICIAR_CONTADOR_DETALLE_MOVIL" });
			dispatch({ "type": "IDENTIDAD_MOVIL_INVALIDA" });
			dispatch({ "type": "CERRAR_DETALLE_MOVIL" });
		},
		actualizaTouchId: () => {
			dispatch({ "type": "REINICIAR_CONTADOR_DETALLE_MOVIL" });  
		},
		descargarCertificado: (sPoliza, sCertificado) => {
			dispatch(descargarCertificadoAzul(sPoliza, sCertificado, true));
		},
		regresar: () => {
			dispatch({ "type": "IDENTIDAD_MOVIL_INVALIDA" });
			dispatch({ "type": "CERRAR_DETALLE_MOVIL" });
		},
		descargarDocumento: (sDocumento, sPoliza, sVersion, sRecibo, bMovil) => {
			dispatch(descargarDocumento(sDocumento, sPoliza, sVersion, sRecibo, bMovil));
		},
		mostrarErrorSesion: () => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "Importante", "mensaje": "Has excedido el tiempo de visualización de la póliza. Para poder acceder a ella se te solicitará verificar tu identidad." });
		},
		savePhoto: (photos, callback) => {

			dispatch(savePhotoToBucket(photos, callback));
			
		},
		reloadData: (poliza, version) => {

		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};
const cameraPlaceholderOdo = require("../../img/dbk_reg_km_init.png");
const cameraPlaceholderVin = require("../../img/dbk_reg_serie.png");
const cameraPlaceholder1 = require("../../img/dbk_reg_front_left.png");
const cameraPlaceholder2 = require("../../img/dbk_reg_front_right.png");
const cameraPlaceholder3 = require("../../img/dbk_reg_back_left.png");
const cameraPlaceholder4 = require("../../img/dbk_reg_back_right.png");

const campoSettings = {
	fontFamily:'Roboto',
	fontStyle: 'normal',
	fontWeight: 'normal',
	mixBlendMode: 'normal',
}

const floatingLabelStyleSettings={
		...campoSettings,
		lineHeight: '24px',
		letterSpacing: '0.5px',
		color: '#0C2040',
		zIndex: 0
}

const floatingLabelFocusStyleSettings={
	...campoSettings,
	lineHeight: '16px',
	letterSpacing: '0.4px',
	color: '#647085',
}

class PagoPorKM extends React.Component {

	state = {
		'kmIni': '',
		'kmFin': '',
		"camara1Photo": cameraPlaceholderOdo,
		"needSubmit1": false,
		"supDer": cameraPlaceholder2,
		"supIzq": cameraPlaceholder1,
		"infDer": cameraPlaceholder3,
		"infIzq": cameraPlaceholder4,
		"vin": cameraPlaceholderVin,
		"supDerEnabled": true,
		"supIzqEnabled": true,
		"infDerEnabled": true,
		"infIzqEnabled": true,
		"vinEnabled": true,
		"supDerSubmit": false,
		"supIzqSubmit": false,
		"infDerSubmit": false,
		"infIzqSubmit": false,
		"vinSubmit": false,
		source: "",
		startCamera: true,
		endCamera: false,
		disableSendButton: true,
		enableTextBox: false,
		enableEndTextBox: false,
		startCameraEnabled: false,
		endCameraEnabled: false,
		disableFirstSection: false,
		disableSecondSection: true,
		infDerFilled: false,
		infIzqFilled:false,
		supDerFilled:false,
		supIzqFilled: false,
		vinFilled: false,
		filledStart: false,
		isActiveModalConfirmation: false,
		isActiveModalAutorizador: false,
		isActiveModalRegistro: false,
		isActiveModalError: false,
		isActiveModalError2: false
	}

	cargarImagen = (sImagen) => {
		var state = {};
		state[sImagen] = true;
		this.setState(state);
	}

	mostrarPantalla = () => {
		if ( !this.state.cargaCompleta ) {
			var _this = this;
			var ini = moment(this.props.appParams.fchVigenciaInicial, "DD/MM/YYYY").valueOf();
			var fin = moment(this.props.appParams.fchVigenciaFinal, "DD/MM/YYYY").valueOf();
			var now = moment().valueOf();

			var color = "#183D7B", vigencia = "90%";

			if (now > fin) {
				color = "#FF6F20";
				vigencia = "100%";
			}

			if (now < fin) {
				vigencia = (((now - ini) * 100) / (fin - ini)) + "%";
			}

			setTimeout(() => {
				$(".contenedor-detalle").addClass("contenedor-detalle-visible");
			}, 300);
			setTimeout(() => {
				$(".detalle-poliza").addClass("detalle-poliza-visible");
			}, 500);
			setTimeout(() => {
				$(".titulo-detalle").addClass("titulo-detalle-visible");
			}, 700);
			setTimeout(() => {
				$(".botones-detalle").addClass("botones-detalle-visible");
			}, 900);
			setTimeout(() => {
				_this.setState({ "vigencia": vigencia, "colorVigencia": color, "cargaCompleta": true });
				_this.props.actualizaTouchId();
			}, 1200);
		}
	}

	validaInactividad = () => {
		if (new Date() > new Date(this.props.callTs + this.props.timeout)) {
			this.props.mostrarErrorSesion();
			this.props.regresar();
			let mensaje = {"return": "home"};
			movil("", mensaje);
			return false;
		} else {
			this.props.actualizaTouchId();
			return true;
		}
	}

	obtenerFechaLimiteInicio = () => {

		moment().locale('es');
		var date = moment(this.props.appParams.fchVigenciaInicial, 'DD/MM/YYYY').add(14, 'days').format('L');
		// .add(15, 'days').format('L')

		return date;

	}

	obtenerFechaLimiteTermino = () => {

		moment().locale('es');
		var date = moment(this.props.appParams.fchVigenciaFinal, 'DD/MM/YYYY').subtract(30, 'days').format('L');
		
		return date;

	}

	regresar = () =>{
		this.props.regresar();
		let mensaje = {"return": "home"};
		movil("", mensaje);
	}

	getDeviceType(){

		if(typeof window.webkit != 'undefined' && window.webkit.messageHandlers) return "iOS";
		if(typeof android_conectam != 'undefined') return "android";
		return "browser";

	}

	activateCameraByDeviceType(payload){

		switch(this.getDeviceType()){
			case 'iOS':
				window.webkit.messageHandlers.callbackHandler.postMessage(payload);
			break;

			case 'android':
				android_conectam.callbackHandler(JSON.stringify(payload.error), JSON.stringify(payload.data));
			break;
		}
	}

	takePhoto(source, enabled){

		if(!enabled) return;

		var payload = {
			"data": {
				"proceso": "camara",
				"return": "savePhoto()"
			},
			"error": "errorHandler"
		};
		
		this.setState({
			source: source
		});

		this.activateCameraByDeviceType(payload);



	}

	savePhoto(){

		switch(this.state.source){
			case "ini":
				this.setState({
					camara1Photo: 'data:image/png;base64,' + window.photo,
					enableTextBox: !this.props.appParams.isStartKmCaptured,
					needSubmit1: true,
					filledStart: true,					
				},()=>{
					if(this.state.infDerFilled && 
						this.state.infIzqFilled && 
						this.state.supDerFilled && 
						this.state.supIzqFilled &&
						this.state.vinFilled &&
						this.state.kmIni){
						this.setState({disableSendButton:false});
					}
				});

			break;

			default:
				const newState= {}
				newState[this.state.source] = 'data:image/png;base64,' + window.photo;
				newState[this.state.source+"Enabled"] = true;
				newState[this.state.source+"Submit"] = true;
				newState[this.state.source+"Filled"] = true;								

				this.setState(newState,()=>{
					if(this.state.infDerFilled && 
						this.state.infIzqFilled && 
						this.state.supDerFilled && 
						this.state.supIzqFilled &&
						this.state.vinFilled &&
						this.state.kmIni){
						this.setState({disableSendButton:false});
					}
				});

		}
		

	}

	componentDidMount(){
		if(this.props.appParams != null && typeof this.props.appParams != 'undefined'){
			if(this.props.appParams.isStartKmCaptured){
				this.setState({
					camara1Photo: this.props.appParams.startPhoto,
					kmIni: String(this.props.appParams.startKm).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
					startCameraEnabled: false,
					enableTextBox: false,
					filledStart: true,					
					disableFirstSection: this.props.appParams.isStartKmCaptured
				});

			}else{

				this.setState({
					startCameraEnabled: this.props.appParams.enabled,
					enableTextBox: this.props.appParams.enabled,
					filledStart: false
				});

			}

			this.setStateCameraPhoto(this.props.appParams, "supIzq");
			this.setStateCameraPhoto(this.props.appParams, "supDer");
			this.setStateCameraPhoto(this.props.appParams, "infIzq");
			this.setStateCameraPhoto(this.props.appParams, "infDer");
			this.setStateCameraPhoto(this.props.appParams, "vin");
		}
	}

	setStateCameraPhoto(poliza, key){
		const newState = {};
		if (poliza[key]){			
			newState[key] = poliza[key];
			newState[key+"Enabled"] = false;			
			newState[key+"Filled"] = true;			
		}else{
			newState[key+"Enabled"] = poliza.enabled;			
		}		
		this.setState(newState);	
	}

	SendPhoto(){
		this.closeModalConfirmationFromChild();

		this.setState({
			enableTextBox: false
		});
		let photos = [];
		if(this.state.needSubmit1){
			photos.push({
				poliza: this.props.appParams.numPoliza,
				version: this.props.appParams.numVersion,
				km: this.state.kmIni.replace(',', ''),
				type: 'ini',
				photo: this.state.camara1Photo
			});
		}
		if(!this.state.filledStart){
			return;
		}
		if(this.validarEnviar("supDer",photos) &&
			this.validarEnviar("supIzq",photos) &&
			this.validarEnviar("infDer",photos) &&
			this.validarEnviar("infIzq",photos) &&
			this.validarEnviar("vin",photos) &&
			this.state.kmIni){		
			this.setState({disableSendButton:true},()=>{
				this.props.savePhoto(photos, (result)=>{

					if(!result.res){
						this.setState({
							startCameraEnabled: true,
							enableTextBox: true,
							disableSendButton: false
						});
					}

					if(result.modal){
						switch(result.modal){
							case 'modalAutorizador':
								this.openModalAutorizadorParent();
								break;
							case 'modalError':
								this.openModalErrorParent();
								break;
							case 'modalRegistro':
								this.openModalRegistroParent();
								break;
							case 'modalError2':
								this.openModalError2Parent();
								break;
							default:
								this.openModalError2Parent();
								break;
						}
					} else
						this.openModalError2Parent();
				});
			});
		}
	}
	validarEnviar(key,photos){
		if(this.state[key+"Submit"]){
			photos.push({
				poliza:this.props.appParams.numPoliza, 
				version: this.props.appParams.numVersion, 
				km: 0, 
				type: key, 
				photo: this.state[key]
			});
		}
		return this.state[key +"Filled"];
	}

	kmInicio(e){
		if(e.target.value.length <= 7){

			this.setState({
				kmIni: e.target.value.replace(',', '').replace(/[^\d,]/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ","),
			});
			if(this.state.infDerFilled && 
				this.state.infIzqFilled && 
				this.state.supDerFilled && 
				this.state.supIzqFilled &&
				this.state.vinFilled &&
				e.target.value){
				this.setState({disableSendButton:false});
			}else{
				this.setState({disableSendButton:true});
			}
		}
	}

	kmFin(e){

		if(e.target.value.length <= 7)

		this.setState({
			kmFin: e.target.value.replace(',', '').replace(/[^\d,]/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ","),
			disableSendButton: e.target.value.length == 0 ? true : false
		});

	}

	ShowConfirmationModal(){
		this.openModalConfirmationParent();
	}

	aceptar() {
		this.props.tagManager({
			dispositivo: this.props.dispositivo,
			type: 'EVENT_CLICK_ENVIAR-PAGO-POR-KM-' + this.state.source.toUpperCase()
		});

		this.closeModalRegistroFromChild();
		let mensaje = {"return": "home"};
		movil("", mensaje);
	}
	aceptarError() {
		this.closeModalErrorFromChild();
	}
	aceptarError2() {
		this.closeModalError2FromChild();
	}
	aceptarAutorizador(){
		this.closeModalAutorizadorFromChild();
		let mensaje = {"return": "home"};
		movil("", mensaje);;
	}
	volver(){
		this.closeModalConfirmationFromChild();
	}

	openModalConfirmationParent = () => {
		let { isActiveModalConfirmation } = this.state;

		if(isActiveModalConfirmation)
		  this.setState({ isActiveModalConfirmation: false})
		else{
		  this.setState({ isActiveModalConfirmation: true});
		}
	}

	closeModalConfirmationFromChild = () => {
		this.setState({ isActiveModalConfirmation: false})
	}

	openModalAutorizadorParent = () => {
		let { isActiveModalAutorizador } = this.state;

		if(isActiveModalAutorizador)
		  this.setState({ isActiveModalAutorizador: false})
		else{
		  this.setState({ isActiveModalAutorizador: true});
		}
	}

	closeModalAutorizadorFromChild = () => {
		this.setState({ isActiveModalAutorizador: false})
	}

	openModalRegistroParent = () => {
		let { isActiveModalRegistro } = this.state;

		if(isActiveModalRegistro)
		  this.setState({ isActiveModalRegistro: false})
		else{
		  this.setState({ isActiveModalRegistro: true});
		}
	}

	closeModalRegistroFromChild = () => {
		this.setState({ isActiveModalRegistro: false})
	}

	openModalErrorParent = () => {
		let { isActiveModalError } = this.state;

		if(isActiveModalError)
		  this.setState({ isActiveModalError: false})
		else{
		  this.setState({ isActiveModalError: true});
		}
	}

	closeModalErrorFromChild = () => {
		this.setState({ isActiveModalError: false})
	}

	openModalError2Parent = () => {
		let { isActiveModalError2 } = this.state;

		if(isActiveModalError2)
		  this.setState({ isActiveModalError2: false})
		else{
		  this.setState({ isActiveModalError2: true});
		}
	}

	closeModalError2FromChild = () => {
		this.setState({ isActiveModalError2: false})
	}

	render() {
		this.mostrarPantalla();

		return(
			<MuiThemeProvider>
			<div id="dbk-pago-por-km" className="polizas-mobile">
				
				{this.state.isActiveModalConfirmation &&
					<Modal closeModalFromChild={() => null}>
						<div className="container">
							<div className="row">
							<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-top no-padding-modal">
									<label className="gnp-material-title-modal">Enviar datos</label>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 margin-modal no-padding-modal">
									<p className=" gnp-material-content-modal">¿Deseas enviar los datos registrados?. Una vez que se envíen, no se podrán modificar.</p>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center no-padding-modal">
									<button type="button" onClick={this.SendPhoto.bind(this)} className="pure-material-button-contained btn-full-width">Continuar</button>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-bottom no-padding-modal">
									<button type="button" onClick={this.volver.bind(this)} className="pure-material-button-outlined btn-full-width">Cancelar</button>
								</div>
							</div>
						</div>
					</Modal>
				}
				
				{this.state.isActiveModalAutorizador &&
					<ModalFullScreen closeModalFromChild={() => null}>
						<img src={require('../../img/dbk-nwb-validacion.png')} style={{width: '100%'}}/>
						<div className="container">
							<div className="row">
							<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-top no-padding-modal">
									<label className="gnp-material-title-modal">Registro en validación</label>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 margin-modal no-padding-modal">
									<p className=" gnp-material-content-modal">Tu información ha sido enviada y será validada. Te invitamos a comunicarte 
											a Línea GNP 55 5227 9000 opción Beneficios Soy Cliente GNP para agilizar tu registro.</p>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-bottom no-padding-modal">
									<button type="button" onClick={this.aceptarAutorizador.bind(this)} className="pure-material-button-contained btn-full-width">Aceptar</button>
								</div>
							</div>
						</div>
					</ModalFullScreen>
				}

				{this.state.isActiveModalRegistro &&
					<ModalFullScreen closeModalFromChild={() => null}>
						<img src={require('../../img/dbk-nwb-alerta.png')} style={{width: '100%'}}/>
						<div className="container">
							<div className="row">
							<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-top no-padding-modal">
									<label className="gnp-material-title-modal">Registro exitoso</label>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 margin-modal no-padding-modal">
									<p className="gnp-material-content-modal">Cuando se aproxime el fin de vigencia de tu Póliza, te recordaremos registrar tu kilometraje final.</p>
									<p className="gnp-material-content-modal">Reduce el uso de tu vehículo y sé un conductor ecológico.</p>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-bottom no-padding-modal">
									<button type="button" onClick={this.aceptar.bind(this)} className="pure-material-button-contained btn-full-width">Aceptar</button>
								</div>
							</div>
						</div>
					</ModalFullScreen>		
				}

				{this.state.isActiveModalError &&
					<Modal closeModalFromChild={() => null}>
						<div className="container">
							<div className="row">
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-top no-padding-modal">
									<img src={require('../../img/warning-new-style.svg')} alt="Error image modal" className="gnp-material-comtent-image" />
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-top no-padding-modal">
									<label className="gnp-material-title-modal">Error al realizar el registro</label>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 margin-modal no-padding-modal">
									<p className=" gnp-material-content-modal">El kilometraje que ingresaste manualmente no coincide con tu fotografía. Revisa el kilometraje de tu vehículo y captura los datos nuevamente.</p>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-bottom no-padding-modal">
									<button type="button" onClick={this.aceptarError.bind(this)} className="pure-material-button-contained btn-full-width">Aceptar</button>
								</div>
							</div>
						</div>
					</Modal>
				}

				{this.state.isActiveModalError2 &&
					<Modal closeModalFromChild={() => null}>
						<div className="container">
							<div className="row">
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-top no-padding-modal">
									<img src={require('../../img/warning-new-style.svg')} alt="Error image modal" className="gnp-material-comtent-image" />
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-top no-padding-modal">
									<label className="gnp-material-title-modal">Error al realizar el registro</label>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 margin-modal no-padding-modal">
									<p className=" gnp-material-content-modal">Servicio no disponible, por favor intente más tarde</p>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-bottom no-padding-modal">
									<button type="button" onClick={this.aceptarError2.bind(this)} className="pure-material-button-contained btn-full-width">Aceptar</button>
								</div>
							</div>
						</div>
					</Modal>
				}
				<div className="container">
					<div className="box-wrap">
						<div className="cards-wrap mt-25 contenedor-detalle">
							<div className="row">
								<div aria-hidden="false">
									<div className="col-xs-2" >
										<img className="smart-trip-img-size" src={require('../../img/smart-trip.png')} />
									</div>
									<div className="col-xs-10">
										<p>
											<b id="title-dbk-ph1">Distintivo bajo kilometraje</b>
											{!this.props.appParams.startDate && this.props.appParams.startLimitDate &&
												<p className="text-contened date-limit-reg">	Fecha límite de registro:<br/> {this.props.appParams.startLimitDate}</p>
											}
											{this.props.appParams.startDate &&
												<p className="text-contened">Fecha de registro:<br/>{this.props.appParams.startDate}</p>
											}
										</p>
									</div>
									<div className="col-xs-12 elements-width">
										<button style={{position:"absolute", display:'none'}} id="cameraEvent" onClick={this.savePhoto.bind(this)}/>
										<p className="text-contened captura-text">
											Captura las fotografías de tu vehículo como muestra el ejemplo:
										</p>
									</div>
								
								
									<div className="col-xs-6 image-cards-left">
										{!this.state.supDerFilled ?
											<Card style={{
												borderRadius: '4px',
												padding: '8px 8px 8px 8px',
											}}
											onClick={this.takePhoto.bind(this, "supDer", this.state.supDerEnabled)}
											>
												<div className="add-photo-container">
													<img className=" " src={cameraPlaceholder2}   className="image-transparency" style={{maxWidth: "100%"}}/>
													<div className="add-photo-centered"><img src={require('../../img/add-photo-new.svg')} alt="Add photo"/></div>
													<div className="add-photo-text-centered">Diagonal delantera derecha</div>
												</div>
											</Card>
											:
											<Card 
											className="height-card-filled"
											onClick={this.takePhoto.bind(this, "supDer", this.state.supDerEnabled)}
											>
												<div>
													<img 
														className="image-filled" 
														src={this.state.supDer} />
													
													<div className="text-card-filled">
														Diagonal delantera derecha
													</div>
												</div>
												
											</Card>}

										{!this.state.infIzqFilled ?		
											<Card style={{
												borderRadius: '4px',
												padding: '8px 8px 8px 8px',
												marginTop: '12px'
											}}
											onClick={this.takePhoto.bind(this, "infIzq", this.state.infIzqEnabled)}
											>
												<div className="add-photo-container">
													<img className=" " src={cameraPlaceholder4} className="image-transparency" style={{maxWidth: "100%"}}/>
													<div className="add-photo-centered"><img src={require('../../img/add-photo-new.svg')} alt="Add photo"/></div>
													<div className="add-photo-text-centered">Diagonal posterior derecha</div>
												</div>
											</Card>
											:
											<Card 
												style={{
													marginTop: '12px'
												}}
												className="height-card-filled"
												onClick={this.takePhoto.bind(this, "infIzq", this.state.infIzqEnabled)} 
												>
												<div>
													<img 
														className="image-filled" 
														src={this.state.infIzq}/>
													
													<div className="text-card-filled">
														Diagonal posterior derecha
													</div>
												</div>
												
											</Card>}
									</div>
									<div className="col-xs-6 image-cards-right" >
										
										{!this.state.supIzqFilled ?
											<Card style={{
												borderRadius: '4px',
												padding: '8px 8px 8px 8px'
											}}
											onClick={this.takePhoto.bind(this, "supIzq", this.state.supIzqEnabled)}
											>
													<div className="add-photo-container">
														<img src={cameraPlaceholder1} className="image-transparency" style={{maxWidth: "100%"}}/>
														<div className="add-photo-centered"><img src={require('../../img/add-photo-new.svg')} alt="Add photo"/></div>
														<div className="add-photo-text-centered">Diagonal delantera izquierda</div>
													</div>
											</Card>
											:
											<Card 
											className="height-card-filled"
											onClick={this.takePhoto.bind(this, "supIzq", this.state.supIzqEnabled)}
											>
												<div>
													<img 
														className="image-filled" 
														src={this.state.supIzq} 
														/>
													
													<div className="text-card-filled">
														Diagonal delantera izquierda
													</div>
												</div>
												
											</Card>}
													
												
										{!this.state.infDerFilled ?			
											<Card style={{
													borderRadius: '4px',
													padding: '8px 8px 8px 8px',
													marginTop: '12px'
												}}
												onClick={this.takePhoto.bind(this, "infDer", this.state.infDerEnabled)}
												>
													<div className="add-photo-container">
														<img className=" " src={cameraPlaceholder3} className="image-transparency" style={{maxWidth: "100%"}}/>
														<div className="add-photo-centered"><img src={require('../../img/add-photo-new.svg')} alt="Add photo"/></div>
														<div className="add-photo-text-centered">Diagonal posterior izquierda</div>
													</div>
												</Card>
												:
												<Card 
													style={{
														marginTop: '12px'
													}}
													className="height-card-filled"
													onClick={this.takePhoto.bind(this, "infDer", this.state.infDerEnabled)}
													>
													<div>
														<img 
															className="image-filled" 
															src={this.state.infDer}
															/>
														
														<div className="text-card-filled">
															Diagonal posterior izquierda
														</div>
													</div>
													
												</Card>}

									</div>
									<div className="col-xs-12 elements-width">
										<p className="text-contened captura-fotos-serie"> Captura las fotografías del número de serie de tu vehículo y tu kilometraje actual: </p>												
									</div>
									<div className="col-xs-6 image-cards-left" >
										{!this.state.vinFilled ? 
											<Card style={{
														borderRadius: '4px',
														padding: '8px 8px 8px 8px',
														marginTop: '10px'
													}}
													onClick={this.takePhoto.bind(this, "vin", this.state.vinEnabled)}
													>
														<div className="add-photo-container">
															<img className="" src={cameraPlaceholderVin}  className="image-transparency" style={{maxWidth: "100%"}}/>
															<div className="add-photo-centered"><img src={require('../../img/add-photo-new.svg')} alt="Add photo"/></div>
															<div className="add-photo-text-centered">No. de serie</div>
														</div>
											</Card>
											:
											<Card 
												style={{marginTop: 10}}
												className="height-card-filled"
												onClick={this.takePhoto.bind(this, "vin", this.state.vinEnabled)}
												>
												<div>
													<img 
														className="image-filled" 
														src={this.state.vin}
														/>
													
													<div className="text-card-filled">
														No. de serie
													</div>
												</div>
												
											</Card>}
									</div>
									<div className="col-xs-6 image-cards-right" >
										{!this.state.filledStart ?
											<Card style={{
												borderRadius: '4px',
												padding: '8px 8px 8px 8px',
												marginTop: '10px'
											}}
											onClick={this.takePhoto.bind(this, "ini", this.state.startCameraEnabled)}
											>
												<div className="add-photo-container">
													<img className="" src={cameraPlaceholderOdo} className="image-transparency" style={{maxWidth: "100%"}}/>
													<div className="add-photo-centered"><img src={require('../../img/add-photo-new.svg')} alt="Add photo"/></div>
													<div className="add-photo-text-centered">Kilometraje actual</div>
												</div>
											</Card>
											:
											<Card 
												style={{marginTop: 10}}
												className="height-card-filled"
												onClick={this.takePhoto.bind(this, "ini", this.state.startCameraEnabled)}
												>
												<div>
													<img 
														className="image-filled" 
														src={this.state.camara1Photo}/>
													
													<div className="text-card-filled">
														Kilometraje
													</div>
												</div>
												
											</Card>}
									</div>
									<div className="col-xs-12 elements-width">
									{this.state.enableTextBox ?
										<TextFiled
										disabled={(!this.state.enableTextBox)? true : false}
										floatingLabelText={!this.state.startCameraEnabled ? "Kilometraje Inicial:" :"Ingresa tu Kilometraje:"}
										fullWidth={true}
										underlineStyle={{borderColor: '#AAC3EE'}}
										underlineFocusStyle={{borderColor: '#AAC3EE'}}
										floatingLabelStyle={floatingLabelStyleSettings}
										floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
										value={this.state.kmIni} 
										onChange={this.kmInicio.bind(this)}  
										type="tel" 
										pattern="[0-9]*" 
										noValidate 
										id="camera-start"  />
									:
										<div className="col-xs-12 elements-width text-consulta-kilometraje">
											<p className="text-contened-consulta-km-label"> Kilometraje inicial: </p>												
											<p className="text-contened-consulta-km-content">{this.state.kmIni}</p>												
										</div>
									}												
									</div>
								
									<div className="col-xs-12 elements-width button-siguiente">
										<button disabled={this.state.disableSendButton} onClick={this.ShowConfirmationModal.bind(this)} id="send-button" type="button" className="pure-material-button-contained btn-full-width">Continuar</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</MuiThemeProvider>
		);
	}
}

export default connect(mapState, mapDispatch)(PagoPorKM);


// WEBPACK FOOTER //
// ./src/movil/polizas/pagoPorKM.cmpt.js